interface BrandMarkProps {
  /**
   * `header` is the page's logo; `footer` sits smaller in a line.
   */
  size?: 'footer' | 'header';
}

/**
 * The Chosen pill wordmark from the brand kit (`public/brand/`).
 */
export function BrandMark({ size = 'footer' }: BrandMarkProps) {
  const sizes = { footer: 'h-8 w-auto', header: 'tablet:h-7.5 h-6.5 w-auto' };

  const classes = {
    image: sizes[size],
  };

  return (
    <img
      alt="Chosen"
      className={classes.image}
      data-testid="brand-wordmark"
      decoding="async"
      height={144}
      src="/brand/wordmark.png"
      width={613}
    />
  );
}
